import { useEffect, useState } from 'react';
import { selectServices } from '../../features/layerSlice';
import { useAppSelector } from '../../store/hooks';
import Coordinate from './components/Coordinate/Coordinate';
import Draw from './components/Draw/Draw';
import GetFeatureInfo from './components/GetFeatureInfo/GetFeatureInfo';
import Highlight from './components/Highlight/Highlight';
import LookLayer from './components/LookLayer/LookLayer';
import MapFit from './components/MapFit/MapFit';
import OlMap from './components/OlMap'
import Rotate from './components/Rotate/Rotate';
import { Style } from './components/Style/Style';
import OlTileLayer from './components/Tile/OlTileLayer'
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setBasemaps } from '../../features/basemapSlice';
import { Tile } from './components/Tile/Tile';
import WKT from 'ol/format/WKT';

export default function MapContainer() {
    const dispatch = useDispatch();
    const services = useAppSelector(selectServices);
    const showPano = useAppSelector(state => state.toolbarState.showPano);
    const show3d = useAppSelector(state => state.toolbarState.show3d);
    const style = useAppSelector(state => state.sharedState.style)
    const refreshLayers = useAppSelector(state => state.sharedState.refreshLayers)
    const token = useAppSelector(state => state.authState.token);
    const basemaps = useAppSelector(state => state.basemap.value);
    const [featureArray, setFeatureArray] = useState()
    useEffect(() => {
        getBasemaps()
        if(token){
            try {
                getGroupZoneGeom()
            } catch (error) {
                localStorage.removeItem('token')
            }
        }
    }, [token])

    const getGroupZoneGeom = async () => {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/user/myGroupsZonesGeom?token=${token}`)
        if(response.data.zones_geom_array && response.data.zones_geom_array.length ===1){
            const featureArray = response.data.zones_geom_array.map((data:any)=> new WKT().readFeature(data))
            const featureArrayTransformed = featureArray.map((data:any)=> data?.getGeometry().transform('EPSG:4326', 'EPSG:3857'))
            setFeatureArray(featureArrayTransformed);
        }
    }

    const getBasemaps = () =>{
         axios.get(process.env.REACT_APP_BASE_URL + 'rest/v1/basemap', { params: { token: token } }).then((res) => {
            const basemaps = res.data.basemaps;
            const selectedBasemap = basemaps.findIndex((basemap: any) => basemap.priority === 1 || basemap.priority === 2);
            basemaps[selectedBasemap].visible = true;
            dispatch(setBasemaps(basemaps));
        })
    }
    return (
        <div className='mapContainer'>

            <OlMap>
                {
                    services.filter(obj => (obj.type === 'VECTOR' && obj.layers.length > 0)).map(service => {
                        return <OlTileLayer refresh={refreshLayers} key={service.id} style={style} serviceType={service.type} url={service.url} isLegendActive={false} layername={service.layers.filter((layer: any) => layer.visible)?.map(layer => { return { name: layer.name, opacity: layer.opacity, labeling: layer.labeling ? 1 : 0 } })}></OlTileLayer>
                    })
                }
                {
                    services.filter(obj => (obj.type === 'PANOGPS' && obj.layers.length > 0)).map(service => {
                        return <OlTileLayer key={service.id} url={service.url} isLegendActive={false} layername={showPano ? [{ name: 'panogps', opacity: 1 }] : []}></OlTileLayer>
                    })
                }
                {
                    services.filter(obj => (obj.type === 'TEMATIK' && obj.layers.length > 0)).map(service => {
                        return <OlTileLayer key={service.id} url={service.url} isLegendActive={true} layername={service.layers.filter(layer => layer.visible).map(layer => { return { name: layer.name, opacity: layer.opacity, labeling: layer.labeling } })}></OlTileLayer>
                    })
                }
                {
                    services.filter(obj => (!(obj.type === 'VECTOR' || obj.type === 'PANOGPS' || obj.type === 'TEMATIK') && obj.layers.length > 0)).map(service => {
                        return <OlTileLayer key={service.id} url={service.url} isLegendActive={false} layername={service.layers.filter(layer => layer.visible).map(layer => { return { name: layer.name, opacity: layer.opacity, labeling: layer.labeling } })}></OlTileLayer>
                    })
                }
                {basemaps.length > 0 && basemaps.map((basemap: any) => basemap.visible &&
                    <Tile
                        layername={basemap.layername}
                        key={basemap.url} url={basemap.url}
                        visible={basemap.visible}
                    />
                )}
                {!show3d && <GetFeatureInfo></GetFeatureInfo>}
                <MapFit featureArray={featureArray}></MapFit>
                <Highlight></Highlight>
                <Style></Style>
                <Coordinate></Coordinate>
                <Draw></Draw>
                <Rotate></Rotate>
                <LookLayer></LookLayer>
            </OlMap>
        </div>
    )
}
